import { render } from "./AppValue.vue?vue&type=template&id=46b4f389&scoped=true"
import script from "./AppValue.vue?vue&type=script&lang=js"
export * from "./AppValue.vue?vue&type=script&lang=js"

import "./AppValue.vue?vue&type=style&index=0&id=46b4f389&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-46b4f389"

export default script